import React from 'react';
import { Icon, Tooltip } from 'antd';

function HelpTip({ title, placement = 'bottom' }) {
  return (
    <Tooltip
      title={title}
      placement={placement}
      mouseEnterDelay={0.15}
      overlayClassName="bsub-help-overlay"
    >
      <button
        type="button"
        className="bsub-help-tip"
        aria-label="More information"
        onClick={(event) => {
          event.preventDefault();
          event.stopPropagation();
        }}
        onMouseDown={(event) => event.stopPropagation()}
      >
        <Icon type="question-circle" />
      </button>
    </Tooltip>
  );
}

export default HelpTip;
